import React from "react";

import "./CollectionCard.css";

export function CollectionCard(props) {
  var url =
    props.parentUrl.charAt(props.parentUrl.length - 1) === "/"
      ? "/af" + props.parentUrl + props.url
      : "." + props.parentUrl + "/" + props.url;

  return (
    <div className="collection-card-container">
      <a href={`${url}`} target="_blank">
        <div>
          <div className="affiliate-collection-card">
            <div className="activity-count">
              <p>{props.activityCount}</p>
            </div>
            <div className="one">
              <div
                style={{
                  backgroundImage: `url(${props.banner_img[0]})`,
                  width: "100%",
                  height: "100%"
                }}
              />
            </div>
            <div
              className="two"
              style={{ backgroundImage: `url(${props.banner_img[1]})` }}
            />
            <div
              className="three"
              style={{ backgroundImage: `url(${props.banner_img[2]})` }}
            />
          </div>
          <div className="affiliate-collection-summary">
            <div className="affiliate-collection-title">
              <h2>{props.collection_name}</h2>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/AffiliateLandingPage/CollectionCard.jsx